export default __webpack_public_path__ + "static/media/en.0a42db62.ftl";